const questions = [
  {
    question:
      "VRAAG 1.1 [2]<br/>Watter EEN beskryf 'n suur?<br/><br/>A. OH-<br/>B. H+<br/>C. elektrone<br/>D. neutraal",
    answer: "b",
    marks: 2,
    topicName: "Acids and Bases",
  },
  {
    question:
      "VRAAG 1.2 [2]<br/>Watter EEN is 'n basis?<br/><br/>A. H+<br/>B. OH-<br/>C. CO2<br/>D. H2O",
    answer: "b",
    marks: 2,
    topicName: "Acids and Bases",
  },
];

export default questions;